import { gql } from 'graphql-request'

import graphQLRequest from '@/CandidateExperience/config/graphQLRequest'

const FETCH_CANDIDATE_APPLICATIONS = gql`
  query candidateApplications($candidateProfileId: ID!) {
    candidateProfile(id: $candidateProfileId) {
      applications {
        nodes {
          id
          position {
            id
            name
            company {
              name
              logoMediumUrl
              brandColor
            }
          }
          interviewRequest {
            id
          }
          status
        }
      }
    }
  }
`

export const fetchCandidateApplications = candidateProfileId => {
  return graphQLRequest(FETCH_CANDIDATE_APPLICATIONS, { candidateProfileId })
}
